import axios from "fetch-api/fetch-api";
import { IActionResponse } from "../interfaces/base-response";

export function removeSavedItemApi(sku: string) {
  return axios.post<IActionResponse>("/delete-saved-item-v3", { sku });
}
